import { themeColor } from './color'

export const border = {
  radius: {
    sm: 6,
    md: 10,
    lg: 16,
    pill: '50px',
  },
  thin: '1px',
  normal: '2px',
  thick: '3px',
  // Hairline: border.thin + ' solid ' + border.light.
  light: themeColor.slate10,
  button: {
    radius: 8,
  },
  input: {
    radius: 8,
  },
  card: {
    radius: '12px',
  },
  dropdown: {
    radius: 10,
  },
  icon: {
    radius: {
      sm: 6,
      md: 10,
    }
  }
}
